import React from 'react';
import { FormattedMessage } from 'react-intl';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';
import { GroupByContainer } from './styles';

interface IGroupByTagProps {
    isDrillDownActive: boolean;
    isTagFilterApplied: boolean;
    setIsTagFilterApplied: Function;
}

function GroupByTag(props: IGroupByTagProps) {
    const { isTagFilterApplied, setIsTagFilterApplied, isDrillDownActive } = props;
    return (
        <GroupByContainer>
            <Form formName="filterReport">
                <UniversalInput
                    label={{
                        text: (
                            <span className="group-by-tag-label">
                                <FormattedMessage id="reports.label.groupByTag" />
                            </span>
                        ),
                    }}
                    inputData={{
                        isInputRequired: false,
                        type: INPUT_TYPES.SWITCH_CHECKBOX,
                        name: 'groupByTag',
                        id: 'groupByTag',
                        classes: [''],
                        checked: isTagFilterApplied,
                        disabled: isDrillDownActive,
                        tooltipText: '',
                        value: isTagFilterApplied,
                        currentData: {},
                        fields: [],
                    }}
                    inputActions={{
                        onFieldChange: e => {
                            setIsTagFilterApplied(e.groupByTag);
                        },
                    }}
                />
            </Form>
        </GroupByContainer>
    );
}

export default GroupByTag;
